import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/Image';
import styles from './styles/styles.module.scss';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import LogoImage from '../../../../assets/images/icons/cuttlefish/logo.svg';
import ActiveProBadge from '../../../../assets/images/icons/cuttlefish/activeProBadge.svg';
import ProBadge from '../../../../assets/images/icons/cuttlefish/proBadge.svg';

const Logo = ({ showProBadge, isProBadgeActive, proBadgeLink, logoLink }) => {
  const altText = StringConstantsMixin.strings.NAVIGATION;
  const proBadge = showProBadge ? (
    <a href={proBadgeLink}>
      <Image alt={altText.PRO_BADGE_ALT_TEXT} className={styles.proBadge} src={isProBadgeActive ? ActiveProBadge : ProBadge} />
    </a>
  ) : (
    ''
  );
  return (
    <div className={styles.container}>
      <a href={logoLink}>
        <Image alt={altText.LOGO_ALT_TEXT} className={styles.logo} src={LogoImage} />
      </a>
      {proBadge}
    </div>
  );
};

Logo.defaultProps = {
  showProBadge: false,
  isProBadgeActive: false
};

Logo.propTypes = {
  showProBadge: PropTypes.bool,
  isProBadgeActive: PropTypes.bool,
  proBadgeLink: PropTypes.string.isRequired,
  logoLink: PropTypes.string.isRequired
};

export default Logo;
